<div class="navButtons-container">
  <div class="buttons navButtons top-m-8x">
    <button id="backBtn" mat-flat-button color="accent" type="button" (click)="back()" *ngIf="!hideBack">
      <mat-icon matPrefix>navigate_before</mat-icon>Back
    </button>
    <span style="flex: 1 1 auto"></span>

    <ng-content select="[nextButton]"></ng-content>
    <ng-container *ngIf="!nextButton">
      <button id="nextBtn" mat-flat-button color="accent" type="button" (click)="next()" *ngIf="!hideNext">
        <mat-spinner
          matSuffix
          [diameter]="16"
          *ngIf="this.showSpinner"
          style="display: inline-block"
          color="white"
          [matTooltip]="'Fetching available utilities.'"
        ></mat-spinner>
        Next
        <mat-icon matSuffix> navigate_next </mat-icon>
      </button>
    </ng-container>
  </div>
</div>
